const AccountsActionTypes = Object.freeze({
  SET_SHOULD_FETCH_ACCOUNTS: '@@Accounts/SetShouldFetchAccounts',
  REQUEST_ALL_ACCOUNTS: '@@Accounts/RequestAllAccounts',
  REQUEST_ALL_ACCOUNTS_OK: '@@Accounts/RequestAllAccountsOk',
  REQUEST_ALL_ACCOUNTS_ERR: '@@Accounts/RequestAllAccountsErr'
});

export { AccountsActionTypes };
